import {observable, action} from 'mobx';
import {score, finance, time} from '../index';
import Parent from './parent';
import settings from '../cultureSettings.json';


export default class CleaningUnit extends Parent{
    @observable percents;
    @observable speed;

    constructor(num, DCName='',culturePercents,speed ,status='',culture='None',amount=0,waste=0,moisture=0,scenario=[]){
        super(num, culture, scenario, amount, moisture, waste, status,DCName);
        this.culturePercents = culturePercents;
        this.speedParams = speed;
        this.speed = 0;
        this.type="cleaning"
    }

    @action setSpeed(speed){
        this.speed = speed;
    }

    @action setUnit(amount=0, culture="None", moisture=0, waste=0, active=false){
        super.setUnit(amount, culture, moisture, waste, active)
        this.speed=0;
    }
    @action shippingFrom(speed){
        if(this.culture!=='None' && this.amount > 0) {
            super.shippingFrom(this.amount)
        }

    }

    @action filling(culture,delta,waste,moisture){
        super.filling(culture,delta,waste,moisture);
        this.setWasteLevel()
    }

    @action setWasteLevel(){
        if(this.wasteLevel > settings[this.culture].baseWaste){
                finance.incDCParams('cleaning', this.culture, this.amount, ((this.wasteLevel - settings[this.culture].baseWaste > 0 ?
                        this.wasteLevel - settings[this.culture].baseWaste : 0)
                ));
                this.wasteLevel = settings[this.culture].baseWaste
            }
    }


}




// WEBPACK FOOTER //
// ./src/shared/stores/objects/CleaningUnit.js